import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import T from '../../app/Locale';
import NemAdgangModal from '../../app2/Modules/Account/EIDModal/EIDModal';
import Button from '../../app2/Components/ComponentButton';
import ModalConfirm from './ModalConfirm';
import ModalUpload from './ModalUpload';
import { redirectToPayment } from '../../app2/Modules/Purchase/API';
import { getGlobalState } from '../../app2/Utils/GlobalState';
const DocumentButton = ({ document, path, action, isNemIdValidated, statusText = '', classes = '', overrideButtonText = false, preSelectedPurchaseType = false, waitingForPaymentBasketId = '' }) => {
    const [showNemAdgangModal, toggleNemAdgangModal] = useState(false);
    const [showConfirmModal, toggleConfirmModal] = useState(false);
    const [showUploadModal, toggleUploadModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const onClick = () => {
        // If document can not be accessed
        if (action === 'payment') {
            setIsLoading(true);
            window.location.href = `/my-documents/purchase-redirect/${document.id}?purchaseType=${preSelectedPurchaseType}`;
            return;
        }
        if (action === 'waiting_for_payment') {
            setIsLoading(true);
            const user = getGlobalState('user');
            redirectToPayment(user.id, waitingForPaymentBasketId);
            return;
        }
        // Always require nem id validation.
        if (!isNemIdValidated) {
            toggleNemAdgangModal(true);
            return;
        }
        // If confirming a document show the modal.
        // If the document is a manual will, not having the update-recommended status, then it should redirect to a specific
        // confirm page for manual wills.
        if (action === 'confirm' && !(document.type === 'will' && document.signatureType === 'manual' && document.status !== 'update-recommended')) {
            toggleConfirmModal(true);
            return;
        }
        // Toggle the upload modal.
        if (action === 'upload') {
            toggleUploadModal(true);
            return;
        }
        setIsLoading(true);
        // Default case is to redirect to the specific path.
        window.location.href = path;
    };
    return (_jsxs("div", { children: [showNemAdgangModal !== false && (_jsx(NemAdgangModal, { closeModal: () => toggleNemAdgangModal(false), redirect: window.location.href })), showConfirmModal && (_jsx(ModalConfirm, { text: statusText, path: path, closeModal: () => toggleConfirmModal(false) })), showUploadModal && (_jsx(ModalUpload, { id: document.id, content: T.translate('documents.upload.content'), closeModal: () => toggleUploadModal(false) })), action && (_jsx(Button, { id: `document-action-${action}`, title: overrideButtonText || T.translate(`documents.actions.${action}`), onClick: onClick, classes: classes, isLoading: isLoading }))] }));
};
DocumentButton.propTypes = {
    document: PropTypes.shape({
        id: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        signatureType: PropTypes.string,
        status: PropTypes.string
    }).isRequired,
    path: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string
    ]).isRequired,
    action: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string
    ]).isRequired,
    statusText: PropTypes.string,
    isNemIdValidated: PropTypes.bool.isRequired,
    classes: PropTypes.string,
    overrideButtonText: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string
    ]),
    preSelectedPurchaseType: PropTypes.bool,
    waitingForPaymentBasketId: PropTypes.string
};
export default DocumentButton;
